import { Overrides } from '@material-ui/core/styles/overrides'

import { greyPalette } from './colors'

const dividerOverride: Overrides = {
  MuiDivider: {
    root: {
      '&.dotted': {
        borderStyle: 'dotted',
        borderTopWidth: '1px',
        backgroundColor: 'unset',
        borderColor: greyPalette[200],
        borderWidth: 0,
      },
      '&.dashed': {
        backgroundColor: 'unset',
        borderColor: greyPalette[200],
        borderWidth: 0,
        borderTopWidth: '1px',
        borderStyle: 'dashed',
      },
      '&.strong': {
        height: '2px',
      },
    },
    light: {
      backgroundColor: greyPalette[100],
    },
  },
}

export default dividerOverride
